import { useSurveyDashboardStore } from '../store/useSurveyDashboard.store';

export const Caption = () => {
  const { captions } = useSurveyDashboardStore((store) => ({
    captions: store.captions,
  }));
  return (
    <div className="flex flex-1 flex-wrap items-center justify-start gap-4 pl-2 md:flex-nowrap md:justify-end md:pl-0">
      {captions?.map((caption) => {
        return (
          <div key={caption.key} className="flex items-center justify-center gap-1 text-center">
            <div
              style={{
                backgroundColor: caption.color || '#000',
                width: '12px',
                height: '12px',
                borderRadius: '100%',
              }}></div>
            <p className=" text-sh-xxxs font-bold">{caption.label}</p>
          </div>
        );
      })}
    </div>
  );
};
